var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 14.7732V15.9999C29.3315 18.8751 28.4005 21.6728 26.679 23.9757C24.9574 26.2785 22.5376 27.9632 19.7803 28.7784C17.0231 29.5937 14.0762 29.4958 11.3791 28.4993C8.68208 27.5029 6.37938 25.6614 4.81445 23.2493C3.24953 20.8373 2.50623 17.984 2.69541 15.115C2.88459 12.246 3.99611 9.515 5.86421 7.32933C7.73231 5.14366 10.2569 3.62041 13.0614 2.98676C15.866 2.35311 18.8002 2.64302 21.4265 3.81323",
    stroke: "#5D9FEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 5.33325L16 18.6799L12 14.6799",
    stroke: "#5D9FEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountVerification);
export default __webpack_public_path__ + "static/media/account-verification.323cf3e1.svg";
export { ForwardRef as ReactComponent };